import { Box, makeStyles, Theme } from "@material-ui/core"
import React, { FC } from "react"
import { LocalizedStrict } from "shared/Modules/Localization/Components/Localized"
import { IMenuProduct } from "shared/Types/appTypes"

type OnlyXLeftTagProps = {
    product: IMenuProduct
    noImage: boolean
}

const useStyles = makeStyles((theme: Theme) => ({
    container: {
        position: "absolute",
        top: theme.spacing(1),
        right: theme.spacing(1),
    },
    tag: {
        padding: `${theme.spacing(0.5)} ${theme.spacing(1)}`,
        fontStyle: "italic",
        fontSize: "0.75rem",
        fontFamily: theme.typography.fontFamily,
    },
}))

export const OnlyXLeftTag: FC<OnlyXLeftTagProps> = ({ product, noImage }) => {
    const classes = useStyles({ noImage })

    const { offerDetails } = product
    if (!offerDetails) return null

    return (
        <Box className={classes.container}>
            <Box className={classes.tag}>
                <LocalizedStrict id="offer-tag-limited-on-sale" vars={{ amount: offerDetails.productsOnSale || 0 }}>
                    <>`Only ${offerDetails.productsOnSale} left`</>
                </LocalizedStrict>
            </Box>
        </Box>
    )
}
